var _defs, _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometerCelsius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 23.73,
    y1: 19.16,
    x2: 39.18,
    y2: 45.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#515a69",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6b7280",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384354",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 23.48,
    y1: 18.73,
    x2: 39.43,
    y2: 46.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 42,
    r: 4.5,
    fill: "#ef4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,27V42",
    fill: "none",
    stroke: "#ef4444",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0; 0 1; 0 0",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39,41.9a7,7,0,1,1-14,0,7.12,7.12,0,0,1,3-5.83v-17a4,4,0,1,1,8,0v17A7.12,7.12,0,0,1,39,41.9ZM32.5,25H36m-3.5-4H36m-3.5,8H36",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#a)",
    stroke: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.44,35A2,2,0,1,1,43,33.53,2,2,0,0,1,42.44,35Zm-2-.79a.89.89,0,0,0,1.26,0,.88.88,0,0,0,0-1.25.83.83,0,0,0-.63-.27.86.86,0,0,0-.63.27.89.89,0,0,0-.26.63A.85.85,0,0,0,40.39,34.16Z",
    fill: "#374151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45,32.29a3.68,3.68,0,0,1,2.61-.85c1.75,0,2.87.68,3.35,2.06a.37.37,0,0,1-.26.54l-.67.23a.46.46,0,0,1-.34,0,.49.49,0,0,1-.19-.28,1.79,1.79,0,0,0-1.89-1.13,2.13,2.13,0,0,0-1.46.45,1.61,1.61,0,0,0-.52,1.3v2.73a1.62,1.62,0,0,0,.52,1.3,2.08,2.08,0,0,0,1.46.46A1.78,1.78,0,0,0,49.49,38a.53.53,0,0,1,.21-.29.5.5,0,0,1,.33,0l.66.24a.38.38,0,0,1,.28.54c-.49,1.38-1.61,2.07-3.37,2.07A3.68,3.68,0,0,1,45,39.71a3.09,3.09,0,0,1-.92-2.37v-2.7A3.07,3.07,0,0,1,45,32.29Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerCelsius);
export default __webpack_public_path__ + "static/media/thermometer-celsius.1884e85cb814ad5b3b2ce4d1e0df2349.svg";
export { ForwardRef as ReactComponent };